import React, { useCallback, useEffect } from "react";
import useIntersectionObserver from "../../utils/useIntersectionObserver";

const Instaposts = () => {
  //   const postLins = [
  //     "https://www.instagram.com/p/C58kSEiRS7_/",
  //     "https://www.instagram.com/p/C6OjetdtE4I/",
  //     "https://www.instagram.com/reel/C9R5Adjusih/",
  //     "https://www.instagram.com/reel/C5YsSJ3uRFw/",
  //   ];

  const handleIntersect = useCallback(() => {
    const links = document.querySelectorAll("a");

    // Iterate over each link and apply styles based on the href attribute
    links.forEach((link) => {
      const href = link.getAttribute("href");
      if (
        href ===
        "https://elfsight.com/instagram-feed-instashow/?utm_source=websites&utm_medium=clients&utm_content=instashow&utm_term=localhost&utm_campaign=free-widget"
      ) {
        console.log("remove");
        link.remove();
      }
    });
  }, []);

  const setObserverRef = useIntersectionObserver(handleIntersect, {
    root: null, // Use the viewport as the root
    rootMargin: "0px 0px -50px 0px", // Adjust to trigger when the element is almost visible
    threshold: 0.1, // Trigger when 10% of the element is visible
  });

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="elfsight-app-5638978c-abdf-41ae-b756-12840f12d5ae"
      ref={setObserverRef}
    ></div>
  );

  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "flex-start",
  //         gap: "10px",
  //         alignItems: "flex-start",
  //         position: "relative",
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: "100%",
  //           height: "100%",
  //           position: "absolute",
  //           top: "0",
  //           left: "0",
  //           zIndex: "10",
  //         }}
  //         onClick={() => fireGtmEvent("insta_posts_clicked")}
  //       ></div>
  //       {postLins.map((url) => {
  //         return <InstagramEmbed url={url} width={328} key={url} />;
  //       })}
  //     </div>
  //   );
};

export default Instaposts;
